var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7941 27.2711C20.2672 27.0038 20.6111 26.5613 20.7501 26.041C20.8892 25.5206 20.812 24.965 20.5356 24.4965L19.4933 22.7297C19.2168 22.2611 18.7638 21.9179 18.2338 21.7756C17.7038 21.6332 17.1403 21.7035 16.6672 21.9708C13.0996 23.9865 11.015 20.453 9.97265 18.6862C8.93034 16.9194 6.84573 13.3858 10.4133 11.37C10.8864 11.1027 11.2303 10.6602 11.3694 10.1398C11.5084 9.61948 11.4313 9.06391 11.1548 8.59532L10.1125 6.82853C9.83607 6.35995 9.38302 6.01675 8.85302 5.87442C8.32302 5.7321 7.75949 5.80232 7.2864 6.06963C2.82691 8.58936 1.19352 11.868 6.40506 20.702C11.6166 29.5359 15.3346 29.7909 19.7941 27.2711Z",
    stroke: "#1F2B6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2875 19.9753C30.2351 16.4219 29.7071 12.6288 27.8197 9.42945C25.9322 6.23008 22.8397 3.88608 19.2215 2.91246M23.8261 18.5087C24.1084 17.4534 24.1761 16.3515 24.0254 15.2659C23.8748 14.1804 23.5086 13.1325 22.948 12.1821C22.3873 11.2317 21.6431 10.3975 20.7578 9.72698C19.8725 9.05651 18.8636 8.56297 17.7885 8.27454M18.394 17.0314C18.5835 16.3204 18.4777 15.5614 18.1001 14.9213C17.7224 14.2811 17.1037 13.812 16.3798 13.6171",
    stroke: "#1F2B6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.78214a89a51fd406caa914b22e2ae68b.svg";
export { ForwardRef as ReactComponent };